module.exports = mcTracerVuePlugin;